export const getNextIdKey = (() => {
  let i = 0;
  const timestamp = Date.now().toString();

  return () => {
    i += 1;
    return `${timestamp + i.toString()}`;
  };
})();
